
















import { Component, Vue } from "vue-property-decorator";
import store from "@/store";
import GuidedHeader from "@/components/GuidedHeader/GuidedHeader.vue";
import GuidedList from "@/components/GuidedList/GuidedList.vue";
import { ListToBeDisplayed } from "@/store/modules/delayCodes/utils";
import { ListItem } from "../store/modules/delayCodes/utils";

@Component({
  components: {
    GuidedHeader,
    GuidedList
  }
})
export default class GuidedMode extends Vue {
  ListToBeDisplayed = ListToBeDisplayed;

  get listToBeDisplayed(): ListItem[] {
    const selectedProcessId = store.state.delayCodes.selectedProcessId;
    const selectedReasonId = store.state.delayCodes.selectedReasonId;
    const selectedStakeholderId = store.state.delayCodes.selectedStakeholderId;
    if (
      selectedProcessId !== null &&
      selectedReasonId !== null &&
      selectedStakeholderId !== null
    ) {
      return [
        {
          id: selectedProcessId,
          value: store.state.delayCodes.processes[selectedProcessId],
          subItemOf: undefined,
          parentOf: []
        },
        {
          id: selectedReasonId,
          value: store.state.delayCodes.reasons[selectedReasonId],
          subItemOf: undefined,
          parentOf: []
        },
        {
          id: selectedStakeholderId,
          value: store.state.delayCodes.stakeholders[selectedStakeholderId],
          subItemOf: undefined,
          parentOf: []
        }
      ];
    } else {
      return [
        {
          id: -1,
          value:
            "!   An unexpected error occured, please go back into guided mode and try to select your delay code again",
          subItemOf: undefined,
          parentOf: []
        }
      ];
    }
  }

  goBack = () => {
    this.$router.back();
  };
}
